/*global angular,env */
'use strict';

angular.module('MrDWebApp')
  .controller('OrderTrackingCtrl', function($scope, $window, $cookies, storage, $http, $state, $stateParams, invoiceFactory, $previousState, $rootScope, order, orderFactory, $interval, sendbird, pushnotes, $location, $timeout) {

    var _tracking_details = this;

    $previousState.memo('caller');

    $rootScope.$broadcast('loading:show');

    _tracking_details.hasLoaded = false;

    _tracking_details.previousState = $previousState.get('caller');

    _tracking_details.activeTab = 'receipt';
    $scope.exceptionOrder = null;

    _tracking_details.token = null;

    _tracking_details.chatPeriodReady = false; //based on order progress (from en-route onwards)
    _tracking_details.chatCutomerMayStart = false; //based on chat config
    _tracking_details.chatStarted = false; //confirmed on the order as a chat state

    _tracking_details.chatSigningIn = false;
    _tracking_details.chatSignedIn = false;
    _tracking_details.showingMap = false;
    _tracking_details.showingChat = false;
    _tracking_details.chatQuickMsgs = [];
    _tracking_details.chatConnecting = false;
    _tracking_details.chatConnected = false;
    _tracking_details.chatMessages = null;
    _tracking_details.chatHistoryLoading = false;
    _tracking_details.chatTempUnavailable = false; //if frozen (ch), muted (u) or banned (u)

    _tracking_details.chatSoundNewMessage = new Audio('/audio/your-turn.mp3');

    //###################################################################################
    //  DRIVER CHAT SIGNUP STATUS
    //###################################################################################
    
    // _tracking_details.token = storage.get('driver-chat-signup-push-token') || null;
    // if (tracking_details.token) {
    //   _tracking_details.chatSignedIn = true;
    //   _tracking_details.onChatSignedUp();
    // }

    //###################################################################################
    //  DRIVER CHAT UTILITIES
    //###################################################################################
    
    var updateChatMsgClass = function(msg) {
      if (msg.messageType==='user') {
        if (msg.sender.userId===sendbird.getUserId()) {
          msg.cssClass = 'me';
          var unreadCount = sendbird.getReadReceipt(msg);
          //console.log('unreadCount',unreadCount);
          if (unreadCount <= 0) {
            msg._statusCode = 8;
            msg._status = 'Read';
          } else {
            msg._statusCode = 7;
            msg._status = 'Sent';
          }
        } else {
          msg.cssClass = 'notme';
        }
      } else {
        msg.cssClass = msg.messageType;
      }
      return msg;
    };

    sendbird.onMessageUpdated = function(message){
      //console.log('Message updated', message, 'in', channel);
      if (!_tracking_details.chatMessages) _tracking_details.chatMessages = [];
      var msg = _tracking_details.chatMessages.find(function(m) {return m.messageId===message.messageId;});
      if (msg) {
        //msg._status = 'sent';
        Object.assign(msg, message);
      }
    };
    sendbird.onMessageReceived = function(message){
      //console.log('Message received', message, 'in', channel);
      if (!_tracking_details.chatMessages) _tracking_details.chatMessages = [];
      _tracking_details.chatMessages.unshift(updateChatMsgClass(message));
      _tracking_details.chatSoundNewMessage.play().catch(function(er){});
    };
    sendbird.onReadReceiptUpdated = function(){
      if (!_tracking_details.chatMessages) return;
      console.log('onReadReceiptUpdated');
      _tracking_details.chatMessages.forEach(updateChatMsgClass);
    };
    var checkChatTempUnavailable = function(){
      _tracking_details.chatTempUnavailable = sendbird.getIsChannelFrozen() || sendbird.getIsUserMuted() || sendbird.getIsUserBanned();
    };
    sendbird.onChangeChannelFreeze = checkChatTempUnavailable;
    sendbird.onChangeMute = checkChatTempUnavailable;
    sendbird.onChangeBan = checkChatTempUnavailable;
    
    //###################################################################################
    //  PUSH NOTIFICATIONS
    //###################################################################################
    
    _tracking_details.setupPN = function() {
      pushnotes.requestPermission()
      .then(function(token){
        _tracking_details.token = token;
        _tracking_details.signup();
      })
      .catch(function(er){
        console.warn('FCM error.', ((er&&er.message)? er.message : er));
        _tracking_details.signup(); //without a token
      });
    };
    
    //###################################################################################
    //  DRIVER CHAT - STATE METHODS
    //###################################################################################
    
    _tracking_details.signup = function() {
      //test required data
      if (!_tracking_details.order || !_tracking_details.order.customer) {

        // SENTRY
        try {
          var msg = 'Driver Chat sign up: Order not loaded.';
          console.warn(msg);
          window.Raven.captureMessage(msg, {level:'warning'});
        } catch (error) {
          console.warn('Could not report error.', error);
        }

        return; // || !_tracking_details.token
      }

      //test signup status
      // if (_tracking_details.chatSignedIn || _tracking_details.chatSigningIn) {
      //   if (_tracking_details.chatSignedIn) console.log('Driver Chat cannot sign up: already signed in. Continuing.');
      //   if (_tracking_details.chatSigningIn) console.log('Driver Chat cannot sign up: already signing in. Continuing.');
      //   _tracking_details.onChatSignedUp();
      //   return;
      // }

      _tracking_details.chatSigningIn = true;
      sendbird.signup(_tracking_details.order.customer.id.toString(), _tracking_details.order.customer.first_name, _tracking_details.token)
      .then(function(){
        //console.log('Customer chat signin done.');
        _tracking_details.chatSignedIn = true;
        _tracking_details.chatSigningIn = false;
        _tracking_details.onChatSignedUp();
        if (_tracking_details.token) storage.set('driver-chat-signup-push-token', _tracking_details.token);
      })
      .catch(function(er){
        _tracking_details.chatSigningIn = false;
        
        // SENTRY
        try {
          var msg = 'Driver Chat sign up: '+ (er.message || er);
          console.warn(msg);
          window.Raven.captureMessage(msg, {level:'warning'});
        } catch (error) {
          console.warn('Could not report error.', error);
        }

      });
    };

    _tracking_details.onChatSignedUp = function() {
      if (_tracking_details.showingChat) {
        _tracking_details.chatConnect();
      }
    };

    _tracking_details.chatConnect = function(){
      //test required data
      if (!_tracking_details.order || !_tracking_details.order.invoice_number) {
        console.log('Driver Chat cannot connect: order not loaded.');
        return;
      }

      //test chat (init) allowed
      if (!_tracking_details.chatStarted && !_tracking_details.chatCutomerMayStart) {
        console.log('Driver Chat cannot connect: customer may not initiate.');
        return;
      }

      //test connect allowed
      if (!_tracking_details.chatSignedIn || !_tracking_details.chatPeriodReady) {
        if (!_tracking_details.chatSignedIn) console.log('Driver Chat cannot connect: user not signed in.');
        if (!_tracking_details.chatPeriodReady) console.log('Driver Chat cannot connect: order not in chat-ready status.');
        return;
      }

      //test connect status
      if (_tracking_details.chatConnecting || _tracking_details.chatConnected) {
        if (_tracking_details.chatConnecting) console.log('Driver Chat cannot connect: already connected.');
        if (_tracking_details.chatConnected) console.log('Driver Chat cannot connect: already connecting.');
        return;
      }

      _tracking_details.chatConnecting = true;
      sendbird.connect(_tracking_details.order.invoice_number)
      .then(function(){
        _tracking_details.chatConnecting = false;
        _tracking_details.chatConnected = true;
        _tracking_details.onChatConnected();
      })
      .catch(function(er){
        _tracking_details.chatConnecting = false;
        //var msg = (er&&er.message)? er.message : (er? er : '');
        //throw new Error('Could not sign customer up to chat. '+msg);

        // SENTRY
        try {
          var msg = 'Driver Chat connect: '+ (er.message || er);
          console.warn(msg);
          window.Raven.captureMessage(msg, {level:'warning'});
        } catch (error) {
          console.warn('Could not report error.', error);
        }
      });
    };

    _tracking_details.onChatConnected = function() {
      _tracking_details.chatHistoryLoading = true;
      sendbird.loadMore(99)
      .then(function(msgs){
        _tracking_details.chatHistoryLoading = false;
        _tracking_details.chatMessages = [];
        //console.log('Prev messages', msgs)
        _tracking_details.chatMessages.push.apply(_tracking_details.chatMessages, msgs.map(function(msg){ return updateChatMsgClass(msg); }));
      })
      .catch(function(er){
        _tracking_details.chatHistoryLoading = false;
        console.warn('Could not load previous messages.', er);
      });
    };

    //###################################################################################
    //  DRIVER CHAT - OPEN/CLOSE CHAT WINDOW
    //###################################################################################
        
    _tracking_details.openChat = function() {
      $scope._rc.driverChatIsOpen = true;
      _tracking_details.showingChat = true;
      _tracking_details.chatConnect(); // make sure

      if (_tracking_details.order) $rootScope.$broadcast('chat:open', _tracking_details.order.invoice_number);
    };

    _tracking_details.closeChat = function() {
      $scope._rc.driverChatIsOpen = false;
      //_tracking_details.chatSignedIn = false; //user stays registered
      _tracking_details.chatConnected = false;
      _tracking_details.showingChat = false;
      sendbird.disconnect();
    };

    //###################################################################################
    //  SEND CHAT MESSAGE
    //###################################################################################
    
    _tracking_details.sendingMessage = false;
    _tracking_details.sendingMessageTimer = false;

    _tracking_details.sendChatMsg = function(text) {
      if (text) {
        //ready
      } else if (_tracking_details.chatMessageInput) {
        text = _tracking_details.chatMessageInput;
        _tracking_details.chatMessageInput = '';
      }
      if (!text) return;

      var msgStub = {id:Date.now().toString(36), cssClass:'me', message:text, _statusCode:1, _status:'Pending'};
      if (!_tracking_details.chatMessages) _tracking_details.chatMessages = [];
      _tracking_details.chatMessages.unshift(msgStub);

      if (!_tracking_details.sendingMessage) {
        _tracking_details.retryMessages();
      }
    };

    _tracking_details.retryMessages = function() {
      if (_tracking_details.sendingMessage && !_tracking_details.sendingMessageTimer) return;
      _tracking_details.sendingMessage = true;

      var msgStub;
      var msgStubIndex;
      for (var i=0; i<_tracking_details.chatMessages.length; i++) {
        var m = _tracking_details.chatMessages[i];
        if (m._statusCode===0||m._statusCode===1) { //pending or failed
          msgStub = m;
          msgStubIndex = i;
        }
      }
      if (msgStub) {
        msgStub._statusCode = 2;
        msgStub._status = 'Sending...';
        sendbird.send(msgStub.message)
        .then(function(msg){
          var ord = _tracking_details.order;
          var inited = ord && ord.delivery && ord.delivery.courier_chat && ord.delivery.courier_chat.initiated;
          if (!inited) {
            $http.post(env.apiURL + 'v3/users/'+_tracking_details.order.customer.id+'/orders/'+_tracking_details.order.id+'/init-courier-chat', {})
            .then(function successCallback(response) {
              console.log('Chat initiated.');
            }, function errorCallback(response) {
              console.warn('Chat could not initiate.');
            });
          }
          updateChatMsgClass(msg);
          msg._statusCode = 7;
          msg._status = 'Sent';
          _tracking_details.chatMessages.splice(msgStubIndex,1,msg); //replace stub with real message
          _tracking_details.sendingMessageTimer = true;
          $timeout(_tracking_details.retryMessages, 1000);
        })
        .catch(function(er){
          msgStub._statusCode = 0;
          msgStub._status = 'Failed';
          _tracking_details.sendingMessageTimer = true;
          $timeout(_tracking_details.retryMessages, 3000);
        });
      } else {
        _tracking_details.sendingMessage = false;
        _tracking_details.sendingMessageTimer = false;
      }
    };

    //###################################################################################
    //  MAP FIT BOUNDS
    //###################################################################################
    
    _tracking_details.showMap = function(){
      $location.search({map:1, chat:$stateParams.chat});
    };

    _tracking_details.isUserControllingMap = false;
    _tracking_details.mapFitBounds = function(pan){
      if (!_tracking_details.showingMap || _tracking_details.isUserControllingMap || !_tracking_details.isMapIdle || !_tracking_details.map_bounds) {
        // if(!_tracking_details.showingMap) console.log("!mapFitBounds :: !_tracking_details.showingMap");
        // else if(_tracking_details.isUserControllingMap) console.log("!mapFitBounds :: _tracking_details.isUserControllingMap");
        // else if(!_tracking_details.isMapIdle) console.log("!mapFitBounds :: !_tracking_details.isMapIdle");
        // else console.log("!mapFitBounds :: !_tracking_details.map_bounds");
        return;
      }
      //console.log('fitBounds', _tracking_details.map_bounds.toString())
      var padding = {bottom:40, left:40, right:40, top:350};
      if (pan) _tracking_details.map.panToBounds(_tracking_details.map_bounds, padding);
      else _tracking_details.map.fitBounds(_tracking_details.map_bounds, padding);
      
      //(optional) restore the zoom level after the map is done scaling
      // var listener = _tracking_details.map.addListener('idle', function () {
      //   _tracking_details.map.setZoom(16);
      //   google.maps.event.clearListeners(_tracking_details.map, 'idle');
      // });
    };

    //###################################################################################
    //  DRIVER MARKER UPDATE
    //###################################################################################
    
    var updateDriverMarker = function(geoloc){
      if (_tracking_details.markerDriver) {
        _tracking_details.markerDriver.setPosition(geoloc);
        //console.log("Marker", geoloc.toUrlValue(),_tracking_details.markerDriver.getPosition().toUrlValue())
      }
      if (_tracking_details.markerDriverLost) _tracking_details.markerDriverLost.setPosition(geoloc);
      if (_tracking_details.markerDriverLostDot) _tracking_details.markerDriverLostDot.setPosition(geoloc);
      if (!_tracking_details.geoEnd) return;
      _tracking_details.map_bounds = new google.maps.LatLngBounds();
      _tracking_details.map_bounds.extend(geoloc);
      _tracking_details.map_bounds.extend(_tracking_details.geoEnd);
      _tracking_details.mapFitBounds(false);
    };

    //###################################################################################
    //  MARKER ANIMATION
    //###################################################################################

    var _anim = {
      startT: 0,
      totalT: 9000, //time between firebase geolocation updates
      elapsedT: 0,
      inProgress: false
    };

    var _animTick = function(now) {
      _anim.elapsedT = now - _anim.startT;
      var progress = _anim.elapsedT / _anim.totalT;
      if (_tracking_details.geoFrom) {
        updateDriverMarker(google.maps.geometry.spherical.interpolate(_tracking_details.geoFrom, _tracking_details.geoTo, progress));
      } else {
        updateDriverMarker(_tracking_details.geoTo);
      }
      if (progress < 1) requestAnimationFrame(_animTick);
      else _anim.inProgress = false;
    };

    var _animStart = function(){
      _anim.startT = performance.now();
      if (_anim.inProgress) return;
      _anim.inProgress = true;
      requestAnimationFrame(_animTick);
    };

    //###################################################################################
    //  DRIVER LOCATION FRESHNESS
    //###################################################################################
    
    _tracking_details.isDriverLocationStale = false;
    var timerLocFresh;
    var resetLocationFreshness = function(){
      clearTimeout(timerLocFresh);
      _tracking_details.isDriverLocationStale = false;
      if (_tracking_details.markerDriver) _tracking_details.markerDriver.setVisible(true);
      if (_tracking_details.markerDriverLost) _tracking_details.markerDriverLost.setVisible(false);
      if (_tracking_details.markerDriverLostDot) _tracking_details.markerDriverLostDot.setVisible(false);
      timerLocFresh = setTimeout(function(){
        _tracking_details.isDriverLocationStale = true;
        var pos;
        if (_tracking_details.markerDriver) {
          pos = _tracking_details.markerDriver.getPosition();
          _tracking_details.markerDriver.setVisible(false);
        }
        if (_tracking_details.markerDriverLost) {
          _tracking_details.markerDriverLost.setVisible(true);
          if (pos) _tracking_details.markerDriverLost.setPosition(pos);
        }
        if (_tracking_details.markerDriverLostDot) {
          _tracking_details.markerDriverLostDot.setVisible(true);
          if (pos) _tracking_details.markerDriverLostDot.setPosition(pos);
        }
      }, 60000);
    };

    //###################################################################################
    //  FIREBASE LOCATION SUBSCRIPTION
    //###################################################################################
    
    var firebaseUnsubscribe;
    var isReceivingFirebaseUpdates = false;
    var trackingDriverId;
    var lastTrackingTime = 0;
    var registerDriverTracking = function() {
      var odr = _tracking_details.order;
      if (isReceivingFirebaseUpdates) {
        if (trackingDriverId === odr.delivery.driver.id) return;
        
        //NEW DRIVER
        if (firebaseUnsubscribe) {
          firebaseUnsubscribe();
          firebaseUnsubscribe = null;
          console.log('Firestore unsubscribed.');
        }
      }
      isReceivingFirebaseUpdates = true;
      trackingDriverId = odr.delivery.driver.id;

      if (!window.firebase_db) return;
      var ref = window.firebase_db
      .collection('driverlocations')
      .doc(''+odr.id)
      .collection('drivers')
      .doc(''+odr.delivery.driver.id);
      firebaseUnsubscribe = ref.onSnapshot(function(doc) {
        if (!doc.exists) return;
        var loc = doc.data();
        //console.log('driver location: ', loc);
        if (loc.tdt_timestamp <= lastTrackingTime) {
          console.log('Stale Firebase location update.');
          return;
        }
        if (!loc.geo_location) {
          console.log('No coordinates from Firebase location update.');
          return;
        }
        lastTrackingTime = loc.tdt_timestamp;
        //if (_tracking_details.geoTo) _tracking_details.geoFrom = _tracking_details.geoTo; //'from' is the previous 'to'
        if (_tracking_details.markerDriver) _tracking_details.geoFrom = _tracking_details.markerDriver.getPosition(); //instead grab last set position of the marker
        _tracking_details.geoTo = new google.maps.LatLng(loc.geo_location.lat, loc.geo_location.lon); // 'to' is the new target
        //_tracking_details.markerDriverAtRestaurant = false;
        console.log('GEO:', _tracking_details.geoFrom? _tracking_details.geoFrom.toUrlValue() : '-', _tracking_details.geoTo? _tracking_details.geoTo.toUrlValue() : '-');
        //geoCurrentFraction = 0; //reset fraction

        if (!_tracking_details.markerDriver) {
          _tracking_details.markerDriver = new google.maps.Marker({
            position: /*_tracking_details.geoFrom? _tracking_details.geoFrom :*/ _tracking_details.geoTo,
            map: _tracking_details.map,
            clickable: false,
            zIndex: 1,
            icon: {url:'/images/website/icMapPinMrDDriver.png', anchor:new google.maps.Point(30,65)} //60 × 75
          });
        }
        /*DEBUG* /new google.maps.Marker({
          position: _tracking_details.geoTo,
          map: _tracking_details.map,
          clickable: false,
          zIndex: 2,
          icon: {url:'/images/website/x-mark-32.png', scaledSize: new google.maps.Size(8,8), anchor:new google.maps.Point(4,4)}
        });//*/

        _animStart();

        if (_tracking_details.mapStage !== 'd') resetLocationFreshness();
      }, function(err){
        console.warn('Firebase error', err);
        //isReceivingFirebaseUpdates = false;
      });
    };

    //###################################################################################
    //  FIREBASE AUTH
    //###################################################################################
    
    var isFirebaseSigningInWithCustomToken = false;
    var isFirebaseSignedInWithCustomToken = false;
    var receiveFirebaseUpdates = function(token) {
      if (isFirebaseSignedInWithCustomToken) {
        registerDriverTracking();
      } else if (!isFirebaseSigningInWithCustomToken) {
        isFirebaseSigningInWithCustomToken = true;
        window.firebase.auth().signInWithCustomToken(token).catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.warn('Firebase signInWithCustomToken failed.', errorCode, errorMessage);
          isFirebaseSigningInWithCustomToken = false;
          //throw error;
        }).then(function(res){
          isFirebaseSignedInWithCustomToken = true;
          resetLocationFreshness();
          registerDriverTracking();
        });
      }
    };

    //###################################################################################
    //  ORDER PROCESS - called only once when the order is loaded
    //###################################################################################
    
    _tracking_details.digestOrder = function() {
      $rootScope.$broadcast('loading:hide');
      _tracking_details.hasLoaded = true;
      
      if (sendbird.isSignedUp()) {
        //already signed up with this PN token
        //NOTE: chat service needs to have the user id and token stored to connect
        _tracking_details.chatSignedIn = true;
        _tracking_details.onChatSignedUp();
        console.log('Driver Chat already signed in. Continuing.');
      }

      var locRestaurant = _tracking_details.order.restaurant.address.geo_location;
      var locCustomer = _tracking_details.order.customer.address.geo_location;

      //init
      var elmMap = document.getElementById('map');
      if (!elmMap) return;

      var latlngRestaurant = new google.maps.LatLng(locRestaurant.lat, locRestaurant.lon);
      _tracking_details.geoEnd = new google.maps.LatLng(locCustomer.lat, locCustomer.lon);

      var center = google.maps.geometry.spherical.interpolate(latlngRestaurant, _tracking_details.geoEnd, 0.5);
      _tracking_details.map = new google.maps.Map(elmMap, {
        center: center,
        minZoom: 13,
        zoom: 14,
        maxZoom: 19,
        disableDefaultUI: true    
      });

      var markerRestaurant = new google.maps.Marker({
        position: latlngRestaurant,
        map: _tracking_details.map,
        clickable: false,
        zIndex: 0,
        icon: {url:'/images/website/icMapPinRestaurant.png'}
      });

      var markerCustomer = new google.maps.Marker({
        position: _tracking_details.geoEnd,
        map: _tracking_details.map,
        clickable: false,
        zIndex: 0,
        icon: {url:'/images/website/icMapPinHouse.png'}
      });

      _tracking_details.map_bounds = new google.maps.LatLngBounds();
      _tracking_details.map_bounds.extend(latlngRestaurant);
      _tracking_details.map_bounds.extend(_tracking_details.geoEnd);
      _tracking_details.mapFitBounds(false);

      _tracking_details.markerDriverLost = new google.maps.Marker({
        position: latlngRestaurant,
        map: _tracking_details.map,
        clickable: false,
        zIndex: 1,
        icon: {url:'/images/website/ic-circle-main-grey.png', anchor:new google.maps.Point(30,66)} //60 × 63
      });
      _tracking_details.markerDriverLostDotIcon = {url:'/images/website/ic-circle-main-grey-dot.gif', w:400, h:400};
      _tracking_details.markerDriverLostDot = new google.maps.Marker({
        position: latlngRestaurant,
        map: _tracking_details.map,
        clickable: false,
        zIndex: 1,
        icon: {
          url:_tracking_details.markerDriverLostDotIcon.url, 
          anchor:new google.maps.Point(_tracking_details.markerDriverLostDotIcon.w*0.03, _tracking_details.markerDriverLostDotIcon.h*0.03),
          scaledSize: new google.maps.Size(_tracking_details.markerDriverLostDotIcon.w*0.06, _tracking_details.markerDriverLostDotIcon.h*0.06)
        }
      });
      resetLocationFreshness();

      _tracking_details.map.addListener('bounds_changed', function(e){
        //console.log("BOUNDS CHANGED");
        _tracking_details.isMapIdle = false;
      });
      _tracking_details.map.addListener('dragstart', function(e){
        //console.log("DRAG STARTED");
        _tracking_details.isUserControllingMap = true;
      });
      _tracking_details.map.addListener('dragend', function(e){
        //console.log("DRAG ENDED");
        _tracking_details.mapResetView();
      });
      _tracking_details.map.addListener('zoom_changed', function(e){
        //console.log("ZOOM CHANGED", e)
        //_tracking_details.mapResetView(); //can't do this here because fitBounds causes this event
      });
      _tracking_details.map.addListener('idle', function(e){
        _tracking_details.isMapIdle = true;
      });

      _tracking_details.processOrderForMap(_tracking_details.order);


      //##  CHAT CONFIG  ################

      $http.get(env.apiURL + 'courier-chat/config')
      .success(function (data){
        var hub = _tracking_details.order.delivery.courier_internals.actual_delivery_hub;
        //data.blacklisted_branches.search(new RegExp('\\b'+hub+'\\b','i'))
        if (data.blacklisted_branches && ~data.blacklisted_branches.search(new RegExp('\\b'+hub+'\\b','i'))) {
          //black listed - ignore `customer_can_initiate`
        } else {
          _tracking_details.chatCutomerMayStart = data.customer_can_initiate === true;
        }
        _tracking_details.setupPN();
      })
      .error(function (er) {
        //ignore
        _tracking_details.setupPN();
      });


      _tracking_details._unreg = $rootScope.$on('chat:message', function (e, obj) { //{invoice_number:"DFD123451",message:"H!",createdAt:Date.now()}
        if (obj.invoice_number !== _tracking_details.order.invoice_number) return;

        // This updated the order chat state to the same state the next poll should update
        if (!_tracking_details.order.delivery.courier_chat) {
          _tracking_details.order.delivery.courier_chat = {initiated:true};
        } else if (!_tracking_details.order.delivery.courier_chat.initiated) {
          _tracking_details.order.delivery.courier_chat.initiated = true;
        }
        _tracking_details.chatStarted = true;
        if (_tracking_details.showingChat) {
          _tracking_details.chatConnect(); // make sure
    
          $rootScope.$broadcast('chat:open', _tracking_details.order.invoice_number);
        }
      });
    };

    //###################################################################################
    //  MAP INTERACTION RESET
    //###################################################################################
    
    _tracking_details.mapResetView = function() {
      _tracking_details.isUserControllingMap = true;
      if (_tracking_details.map_timer) clearTimeout(_tracking_details.map_timer);
      _tracking_details.map_timer = setTimeout(function(){
        console.log('RESETTING VIEW AFTER USER INTERACTION');
        _tracking_details.isUserControllingMap = false;
        _tracking_details.mapFitBounds();
      }, 6000);
    };

    //###################################################################################
    //  ORDER PROCESS FOR DRIVER TRACKING
    //###################################################################################
    
    _tracking_details.processOrderForMap = function(odr) {

      //console.log('DELIVERY', _tracking_details.order.delivery);

      //console.log("ORDER STATE", _tracking_details.order.status);
      _tracking_details.chatPeriodReady = [/*'en_route_to_collection',*/'at_restaurant','en_route_to_delivery','nearby','doorbell'].indexOf(_tracking_details.order.status) >= 0;

      if (_tracking_details.order.delivery.courier_chat && _tracking_details.order.delivery.courier_chat.initiated) {
        _tracking_details.chatStarted = true;
      }

      if (_tracking_details.showingChat) {
        _tracking_details.chatConnect();
      }

      if (!odr.tracking_messages) return;

      //map animation stage update
      var msgs = odr.tracking_messages.filter(function(m) {return m.state===2;});
      if (msgs.length === 1) {
        var msg = msgs[0];
        //console.log('Tracking Message Type:', msg.type);
        switch (msg.type) {
          case 'food-on-the-way':
            _tracking_details.mapStage = 'a';
            break;
          case 'waiter-close-by':
            _tracking_details.mapStage = 'b';
            break;
          case 'waiter-arrived':
            _tracking_details.mapStage = 'c';
            break;
          case 'food-delivered':
          //default:
            console.log('DELIVERED');
            _tracking_details.mapStage = 'd';
            _tracking_details.geoloc = null; //hide button
            _tracking_details.isDriverLocationStale = false;
            _tracking_details.chatConnected = false;
            clearTimeout(timerLocFresh);
            var locCustomer = _tracking_details.order.customer.address.geo_location;
            updateDriverMarker(new google.maps.LatLng(locCustomer.lat, locCustomer.lon));

            $rootScope.$broadcast('chat:end', _tracking_details.order.invoice_number);

            if (firebaseUnsubscribe) {
              firebaseUnsubscribe();
              firebaseUnsubscribe = null;
              console.log('Firestore unsubscribed.');
            }
            break;
          default:
            //console.log('Ignored driver tracking message type', msg.type);
            break;
        }
      }

      //time stamps
      var mg;
      var tm = function(s){var a = s? s.split(/[ :-]/g) : ''; return a? a[3]+':'+a[4] : '';};
      mg = odr.tracking_messages[1];
      _tracking_details.mapTimeA = mg? tm(mg.time) : '';
      mg = odr.tracking_messages[2];
      _tracking_details.mapTimeC = mg? tm(mg.time) : '';
      mg = odr.tracking_messages[3];
      _tracking_details.mapTimeD = mg? tm(mg.time) : '';

      //console.log("MSG Types:", odr.tracking_messages.filter(m => m.state===2).map(m => m.type));
      odr.tracking_messages.forEach(function(m){
        if (('action_commmand' in m) && m.action_commmand.command === 'cmd_driver_tracking_firebase') {
          receiveFirebaseUpdates(m.action_commmand.payload.cmd_driver_tracking_firebase.custom_token);
        }
      });

    };

    var getOrder = function(id){
      // return new Promise(function(resolve,reject){
      //   var t = localStorage.getItem('t');
      //   if (!t) return reject();
      //   var obj = JSON.parse(t);
      //   var a=obj.a, o=obj.o, p=obj.p, m=obj.m;
      //   if (!a||!o||!p||!m) return reject();
      //   fetch(p, {method:m, body: JSON.stringify({a:a,o:o}), headers:{'Content-Type':'application/json'},})
      //   .then(function(res){ return res.json(); })
      //   .then(function(odr){ if (odr.error) throw odr; resolve(odr); })
      //   .catch(function(er){ reject(); });
      // });
      return Promise.reject();
    };

    getOrder($stateParams.orderID).then(function(odr){
      _tracking_details.order = odr;
      try {
        _tracking_details.digestOrder();
      } catch (error) {
        console.error(error);
      }
    }).catch(function(){
      if($scope._rc.trackingOrder && $scope._rc.trackingOrder.id === $stateParams.orderID){
        //Don't re-query the order... load from root scope.
        _tracking_details.order = $scope._rc.trackingOrder;
        _tracking_details.digestOrder();
      } else {
        _tracking_details.order = $scope._rc.trackingOrder = order; //injected `order` is a proimise
        _tracking_details.order.$promise.then(function () {
          _tracking_details.digestOrder();
        });
      }
    });
  
    _tracking_details.phase = 0;
    _tracking_details.mapStages = '';
    _tracking_details.mapStage = 'a';
    _tracking_details.mapTimeA = '';
    _tracking_details.mapTimeC = '';
    _tracking_details.mapTimeD = '';

    if($state.current.name === 'tracking') {
      $scope._rc.bodyClass = 'html-tracking';

      var success = function (response) {
        $rootScope.$broadcast('loading:hide');
        _tracking_details.hasLoaded = true;
        angular.extend(_tracking_details.order, response);
        $scope._rc.trackingOrder = _tracking_details.order;

        _tracking_details.processOrderForMap(_tracking_details.order);

        if (_tracking_details.order.status === 'delivered' ||
           (_tracking_details.order.status === 'restaurant_accepted' && _tracking_details.order.type === 'collect')) {
              _tracking_details.stopTimer();
        } else if (
          _tracking_details.order.status === 'cancelled' ||
          _tracking_details.order.status === 'failed_delivery_injection' ||
          _tracking_details.order.status === 'failed_delivery'
        ) {
            _tracking_details.stopTimer();
            // $state.go('exceptions', {
            //   orderID: _tracking_details.order.id,
            //   userID: _tracking_details.order.customer.id,
            //   statusID: _tracking_details.order.status
            // });
          // console.log("exception", response);
          $scope.exceptionOrder = response;
        }
      };

      _tracking_details.trackingTimer = $interval(function () {
        _tracking_details.phase += 1;
        // _tracking_details.loadingClass = 'phase-' + _tracking_details.phase;
        if (_tracking_details.phase === 8) {

          _tracking_details.phase = 0;
          
          getOrder().then(function(odr){
            success(odr);
          }).catch(function(){
            orderFactory.get({
              userID: _tracking_details.order.customer.id,
              orderID: _tracking_details.order.id
            }, null, success,
            function err() {
              /* @todo Add Event */
              $rootScope.$broadcast('loading:hide');
            });
          });

        }
      }, 3000);
    } else {
      $scope._rc.bodyClass = 'html-details';
    }

    _tracking_details.stopTimer = function(){
      setTimeout(function() { //WITHOUT THIS TIMEOUT THE UI DOES TEMPLATE BOUND VARIABLES DO NOT REFLECT
        if (angular.isDefined(_tracking_details.trackingTimer)) {
          $interval.cancel(_tracking_details.trackingTimer);
          _tracking_details.trackingTimer = undefined;
        }
      }, 100);
    };

    $scope.$on('$destroy', function() {
      
      // Make sure that the interval is destroyed too
      _tracking_details.stopTimer();

      //unsubscribe to firebase
      if (firebaseUnsubscribe) {
        firebaseUnsubscribe();
        firebaseUnsubscribe = null;
        console.log('Firestore unsubscribed.');
      }

      $scope._rc.driverChatIsOpen = false;

    sendbird.onMessageUpdated = null;
    sendbird.onMessageReceived = null;
    sendbird.onReadReceiptUpdated = null;
    sendbird.onChangeChannelFreeze = null;
    sendbird.onChangeMute = null;
    sendbird.onChangeBan = null;
      sendbird.disconnect();
      if (_tracking_details._unreg) {
        _tracking_details._unreg();
      }

      //clear map event listeners
      if (_tracking_details.map) {
        google.maps.event.clearListeners(_tracking_details.map, 'dragend');
        google.maps.event.clearListeners(_tracking_details.map, 'zoom_changed');
      }

      //if (geoInterpolationInterval) clearInterval(geoInterpolationInterval);
    });

    _tracking_details.newOrderButtonClick = function(){

      $scope._rc.newOrderSoft();
      if ($scope._rc.variables.address.street_name){ // check for only street-name here. Assuming the rest..
        $state.go('location',{
          lat: $scope._rc.variables.address.latitude,
          lng: $scope._rc.variables.address.longitude,
          street_name: $scope._rc.variables.address.street_name
        });
      } else {
        if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
      }
  
    };


    _tracking_details.sendInvoice = function(){
      if(order.email === order.original){
        invoiceFactory.invoice(order.id);
      } else {
        invoiceFactory.invoiceAlternative(order.id,order.email);
      }
    };
  
    _tracking_details.promptSendInvoice = function(odr){
    
      $rootScope.$broadcast('global_message:show',{
        'name': 'send_invoice',
        'for_state': 'details',
        'error' : {
          'friendly_message': 'Send order invoice to the following email address.'
        },
        'confirm' : {
          'label': 'Send Invoice',
          'action': 'action',
          'value': {'id' : odr.id, 'email': odr.customer.email, 'original': odr.customer.email},
          'value_object': _tracking_details
        },
        'deny' : {
          'label': 'Cancel',
          'action': 'close',
          'value': true,
          'value_object': null
        }
      });
      
    };

    //###################################################################################
    //  PUSH NOTIFICATIONS
    //###################################################################################
    
    _tracking_details.showingMap = $stateParams.map === '1';

    if ($stateParams.chat === '1') _tracking_details.openChat();

    $scope.$on('$locationChangeSuccess', function(e, newUrl, oldUrl, newState, oldState) {
      // parse query params
      //console.log('PATH', newUrl,$stateParams.orderID);
      var params = {};
      var len = newUrl.indexOf('?');
      var ar = (len>=0)? newUrl.substring(len+1).split('&') : [];
      for (var i=0; i<ar.length; i++) {
        var p = ar[i].split('=');
        if (p.length === 2) params[p[0]] = p[1];
      }
      //console.log('Param change', params);

      //handle change
      _tracking_details.showingMap = params.map === '1';
      if (params.chat === '1') {
        if (!_tracking_details.showingChat) _tracking_details.openChat();
      } else {
        if (_tracking_details.showingChat) _tracking_details.closeChat();
      }

    });

    _tracking_details.switch = function(feature){
      var map = $stateParams.map === '1';
      var chat = $stateParams.chat === '1';
      switch (feature) {
        case 'chat':
          chat = !chat;
          break;
        case 'map':
          map = !map;
          break;
      }
      $location.search({map:(map?'1':'0'), chat:(chat?'1':'0')});
    };

    window.addEventListener('remote-config-loaded', function() {
      $rootScope.$apply(function () {
        _tracking_details.chatQuickMsgs = window.config.chat_message_templates;
      });
    });
    if (window.config.chat_message_templates) {
      _tracking_details.chatQuickMsgs = window.config.chat_message_templates;
    }

});
